export var getPaylinkScenarioMapper = function (data) {
    var result = [];
    if (data && data.length > 0) {
        result = data.map(function (item) {
            return {
                scenarioid: item.scenarioid,
                reasonid: item.reasonid,
                reasonname: item.reasonname,
                stakeholder: item.stakeholder,
                sourceid: item.sourceid,
                trigger: item.trigger,
                communicationtemplate: item.communicationtemplate,
                createddate: item.createddate,
                updateddate: item.updateddate,
                active: item.active,
                paymentlinkvaildity: item.paymentlinkvaildity
            };
        });
    }
    console.log("Result in mapper 111111111", result);
    return result;
};
